import { render, staticRenderFns } from "./LayoutsEdit.vue?vue&type=template&id=1442b15a&"
import script from "./LayoutsEdit.vue?vue&type=script&lang=js&"
export * from "./LayoutsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports